import { Box, Center, Group, ScrollArea, Table, Text } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSelectFlagData } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import { useQuery } from "@tanstack/react-query";
import { FileUploadHandler } from "./FileUploadHandler";
import DownloadDocument from "./DownloadDocument";
import { TableNoResults } from "../../../../components/TableNoResults/TableNoResults";
import FilesTableSkeleton from "../../../../components/Skeletons/FlagDetailsSkeletons/FilesTableSkeleton";

const RelatedDocumentsTable = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const flagData = useSelectFlagData();

  const files = flagData?.files || [];

  const { isLoading } = useQuery({
    queryKey: ["flag-details", id],
    enabled: false, // only reads from store
  });

  const rows = files.map((file) => (
    <Table.Tr key={file.id}>
      <Table.Td>{file.name}</Table.Td>
      <Table.Td w={160} align="center">
        <DownloadDocument {...file} />
      </Table.Td>
    </Table.Tr>
  ));

  if (isLoading) {
    return <FilesTableSkeleton />;
  }

  return (
    <Box>
      <Group justify="space-between">
        <Text fw={700} p="md">
          {t("flagDetails.documentsTable.relatedDocuments")}
        </Text>
        <FileUploadHandler id={id} refetch={() => {}} />
      </Group>
      <ScrollArea h={300}>
        <Table withColumnBorders stickyHeader withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t("flagDetails.documentsTable.fileName")}</Table.Th>
              <Table.Th>
                <Center>{t("flagDetails.documentsTable.download")}</Center>
              </Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.length > 0 ? (
              rows
            ) : (
              <TableNoResults colSpan={2} />
            )}
          </Table.Tbody>
        </Table>
      </ScrollArea>
    </Box>
  );
};

export default RelatedDocumentsTable;
